import HelpCenterComp from 'react-components/help-center-comp/help-center-comp';
import Button from 'wa-storybook/components/general/button/button';
import styles from './resend-invitation-success.module.scss';
import PictureRetinaAssets from 'wa-storybook/components/general/picture-fill-assets/picture-fill-assets';
import { Link } from 'router/custom-link';
import { getZendeskLink } from 'state/global/actions';

const ResendInvitationSuccess = () => (
  <div className={styles.container}>
    <div className={styles.content}>
      <h1 className={styles.title}>
        {polyglot.t('sign_up.invitation.check_your_email')}
      </h1>
      <div className={styles.details}>
        {polyglot.t('sign_up.invitation.receive_telus')}
      </div>
      <PictureRetinaAssets
        url={require('./assets/Email_LW.png')}
        url2x={require('./assets/Email_LW@2x.png')}
      />
      <div className={styles.button}>
        <Link to='/signup/invitation'>
          <Button
            dataHook='got-it'
            text={polyglot.t('sign_up.invitation.got_it')}
          />
        </Link>
      </div>
    </div>
    <div className={styles.info}>
      <HelpCenterComp
        helpText={polyglot.t(
          'sign_up.invitation.help_and_accessibility_text_link',
          {
            urlGettingStarted: getZendeskLink({ key: 'getting_started' }),
            urlAccessibilityTips: getZendeskLink({
              key: 'accessibility_tips',
            }),
          },
        )}
      />
    </div>
  </div>
);

ResendInvitationSuccess.displayName = 'ResendInvitationSuccess';

export default ResendInvitationSuccess;
